import React, { useState, useEffect } from "react";
import { errorBackendMsg } from "helpers/helpers";
import logo from "assets/logo-avellaneda.png";
import axios from "helpers/API";
import { useLocation } from "react-router-dom";
import { parserJsonTemplate } from "externo/templatePdf/utilsPdf";
import Aviso from "componentes/Aviso";
import TurnoPdf from "./templatePdf/TurnoPdf";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";

function DetalleTurno(props) {
  const location = useLocation();
  //APIMENSAJE
  const [msg, setMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);
  const errorApi = (msg) => {
    setIsError(true);
    setMostrarMensaje(true);
    setMsg(msg);
  };
  // Datos Turno
  const [datosTurno, setDatosTurno] = useState(null);
  // Loading
  const [estaCargando, setEstaCargando] = useState(true);

  useEffect(() => {
    getTurnoReservado();
    console.log(location);
  }, []);

  // Formato
  const esNegrita = (palabra) => palabra.includes("[");

  const eliminarBrackets = (palabra) => {
    const regex = /(\[)|(\])/g;
    const str = palabra.replace(regex, "");
    return str;
  };

  const guion = () => "-";

  const wrapperText = (str) => {
    const texto = str.trim();
    const palabras = texto.split(" ");
    let salida = "";
    palabras.forEach((palabra) => {
      if (esNegrita(palabra)) {
        salida += " <b>" + eliminarBrackets(palabra) + "</b> ";
      } else {
        salida += " " + palabra + " ";
      }
    });
    return "<div>" + guion() + salida + "</div>";
  };

  function parserFormatoImpresion(estructura) {
    if (!estructura) {
      return false;
    }
    estructura = JSON.parse(estructura);
    const itemsListado = estructura.items.map((item, index) => (
      <div
        key={index}
        dangerouslySetInnerHTML={{ __html: wrapperText(item) }}
      ></div>
    ));
    return (
      <>
        <div>
          <h5 className="text-center">
            <u>{estructura.titulo}</u>
          </h5>
          <div>{itemsListado}</div>
        </div>
      </>
    );
  }
  // Fin Formato

  function parserLeyenda1(estructura) {
    const itemsListado = estructura.items.map((item) => (
      <div>{`- ${item}`}</div>
    ));
    return (
      <>
        <div>
          <h4>{estructura.titulo}</h4>
          <div>{itemsListado}</div>
        </div>
      </>
    );
  }

  const getTurnoReservado = () => {
    axios
      .post("/turnos/obtener", {
        nroTurno: props.nroTurno ? props.nroTurno : location.state.nroTurno,
        nroDoc: props.nroDoc ? props.nroDoc : location.state.nroDoc,
      })
      .then(function (response) {
        if (response.data) {
          if (response.data.error) {
            setMsg(response.data.msg);
            setEstaCargando(false);
            setDatosTurno(false);
          } else {
            // Exito
            setDatosTurno(parserJsonTemplate(response.data));
            setEstaCargando(false);
          }
        } else {
          setMsg(response.data.msg);
          setEstaCargando(false);
        }
      })
      .catch(function (error) {
        errorApi(errorBackendMsg(error));
        setEstaCargando(false);
      });
  };

  const styles = {
    header: {
      backgroundColor: "var(--color-primario-mda)",
      color: "white",
    },
    headerLogo: {
      backgroundColor: "var(--color-primario-mda)",
      color: "white",
      margin: "auto",
    },
  };

  return (
    <>
      {estaCargando ? (
        <p>Cargando</p>
      ) : (
        <>
          {!datosTurno ? (
            <Grid container>
              <Grid item md={12} style={{ margin: 30 }}>
                <Typography variant="h5"> No existe Turno</Typography>
              </Grid>
            </Grid>
          ) : (
            <Grid container style={{ margin: 20 }}>
              <Grid item md={12}>
                <Card>
                  <CardHeader
                    style={{
                      backgroundColor: "#83c442",
                      color: "white",
                      textAlign: "right",
                    }}
                    avatar={<img src={logo} />}
                    title="Comprobante de Asignación de Turno"
                    subheader="Municipalidad de Avellaneda"
                    subheaderTypographyProps={{
                      color: "white",
                    }}
                  />
                  <CardContent>
                    <Grid container>
                      <Grid item md={12}>
                        <Typography variant="h5">Datos del Turno</Typography>
                      </Grid>
                      <Grid item md={12}>
                        <Typography variant="p">
                          <strong>Nro Turno:</strong> {datosTurno.nroTurno}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Lugar:</strong> {datosTurno.lugar}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Servicio:</strong> {datosTurno.servicio}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Fecha:</strong> {datosTurno.fecha}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Hora:</strong> {datosTurno.hora}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Padrón:</strong> {datosTurno.padron}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Tipo Padrón:</strong> {datosTurno.tipoPadron}
                        </Typography>
                      </Grid>
                      <Grid item md={12} style={{ marginTop: 20 }}>
                        <Typography variant="h5">
                          Datos del solicitante
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>Solicitante: </strong> {datosTurno.nombre}
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="p">
                          <strong>DNI: </strong> {datosTurno.dni}
                        </Typography>
                      </Grid>
                      <Grid item md={12}>
                        <Typography variant="p">
                          <strong>Condición del Suscriptor: </strong> {datosTurno.conSuscriptor}
                        </Typography>
                      </Grid>
                      <Grid item md={12} style={{ marginTop: 20 }}>
                        <strong>{datosTurno.leyenda}</strong>
                      </Grid>
                      <Grid item md={12} style={{ marginTop: 20 }}>
                        <Button variant="outlined" color="primary">
                          <TurnoPdf
                            nombreArchivo="comprobante.pdf"
                            data={datosTurno}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
}

export default DetalleTurno;
